export function getLayer(key: number): string {
  const str = key.toString().split("").join("_");
  if (key >= 1000) {
    return `layer_s_${Math.floor(key / 1000)}`;
  } else if (key === 666) {
    return "layer_game_over";
  }
  return `layer_${str}`;
}
